/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li1_TextInputs */

const tr_onbilgi_s11_li1_text = /** @type {(inputs: Onbilgi_S11_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en az 5 Mbps stabil bağlantı önerilir; 1 Mbps minimum.`)
};

const en_onbilgi_s11_li1_text = /** @type {(inputs: Onbilgi_S11_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a stable connection of at least 5 Mbps is recommended; 1 Mbps minimum.`)
};

const de_onbilgi_s11_li1_text = /** @type {(inputs: Onbilgi_S11_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`empfohlen wird eine stabile Verbindung von mindestens 5 Mbps; 1 Mbps Minimum.`)
};

const ru_onbilgi_s11_li1_text = /** @type {(inputs: Onbilgi_S11_Li1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`рекомендуется стабильное соединение не менее 5 Мбит/с; минимум 1 Мбит/с.`)
};

/**
* | output |
* | --- |
* | "a stable connection of at least 5 Mbps is recommended; 1 Mbps minimum." |
*
* @param {Onbilgi_S11_Li1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li1_text = /** @type {((inputs?: Onbilgi_S11_Li1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li1_text(inputs)
	if (locale === "de") return de_onbilgi_s11_li1_text(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li1_text(inputs)
	return tr_onbilgi_s11_li1_text(inputs)
});